module.exports = __webpack_public_path__ + "img/header.362005d9.svg";